const SET_MEMBER_HISTORICAL_NOTICES = 'SET_MEMBER_HISTORICAL_NOTICES';
const RESET_MEMBER_HISTORICAL_NOTICES = 'RESET_MEMBER_HISTORICAL_NOTICES';

export const MEMBER_HISTORICAL_NOTICES_ACTION_TYPES = {
    SET_MEMBER_HISTORICAL_NOTICES,
    RESET_MEMBER_HISTORICAL_NOTICES,
};
